import { PatientMedicationDetail } from "~/common/types";

export const generateFrequency = ({
  frequency: { description, abbreviation },
  as_needed,
}: PatientMedicationDetail) =>
  `${description} (${abbreviation})${as_needed ? ", as needed" : ""}`;
